
export enum ArchiveControlCd {
	ACTIVE_PRO = 'ActivePro',
	FLAGGED_FOR_ARCHIVE = 'FlaggedForArchive',
	RETRIEVED_FROM_ARCHIVE = 'RetrievedFromArchive'}

